module.exports = __webpack_public_path__ + "static/media/otherThings2.726572df.png";